import { createContext, useContext } from 'react'

type ExperienceMode = 'search' | 'resident'

interface ExperienceContextValue {
  mode: ExperienceMode
  isResolved: boolean
  canSearch: boolean
  canResident: boolean
  canSwitch: boolean
  setMode: (mode: ExperienceMode) => void
}

const ExperienceContext = createContext<ExperienceContextValue | null>(null)

/**
 * Reads the active QuickPass experience (the RBC-style "two lands, one identity"
 * model): which land the renter is in — apartment Search vs Resident life —
 * whether they qualify for each, and a setter to switch lands. Throws outside
 * the provider.
 *
 * @returns {ExperienceContextValue}
 */
const useExperience = (): ExperienceContextValue => {
  const context = useContext(ExperienceContext)
  if (context === null) {
    throw new Error('useExperience must be used within an ExperienceProvider')
  }
  return context
}

export {
  ExperienceContext,
  type ExperienceContextValue,
  type ExperienceMode,
  useExperience,
}
